import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/wolf-cto-logo.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background/95 backdrop-blur-md shadow-md py-3"
          : "bg-background/80 backdrop-blur-sm py-4 lg:py-5"
      }`}>
      <div className="section-container flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="Wolf CTO"
            width={480}
            height={198}
            className="h-10 lg:h-12 w-auto"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8">
          <Link
            to="/"
            className="text-muted-foreground hover:text-navy font-medium transition-colors">
            Home
          </Link>
          <Link
            to="/case-study"
            className="text-muted-foreground hover:text-navy font-medium transition-colors">
            Case Studies
          </Link>
          <Link
            to="/about"
            className="text-muted-foreground hover:text-navy font-medium transition-colors">
            About
          </Link>
          <Button
            variant="gold"
            size="lg"
            className="text-white font-bold bg-gradient-to-br from-gold to-orange-400 hover:from-gold-dark hover:to-orange-500"
            asChild>
            <Link to="/get-started">Get Started</Link>
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden p-2 text-navy"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu">
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-background shadow-lg border-t border-border animate-fade-in">
          <nav className="section-container py-6 flex flex-col gap-4">
            <Link
              to="/"
              className="text-muted-foreground hover:text-navy font-medium py-2 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}>
              Home
            </Link>
            <Link
              to="/case-study"
              className="text-muted-foreground hover:text-navy font-medium py-2 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}>
              Case Studies
            </Link>
            <Link
              to="/about"
              className="text-muted-foreground hover:text-navy font-medium py-2 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}>
              About
            </Link>
            <Button
              variant="gold"
              size="lg"
              className="mt-2 text-white font-bold bg-gradient-to-br from-gold to-orange-400 hover:from-gold-dark hover:to-orange-500"
              asChild>
              <Link
                to="/get-started"
                onClick={() => setIsMobileMenuOpen(false)}>
                Get Started
              </Link>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
